window.slate = window.slate || {}, slate.Variants = function() {
    function t(t) {
        this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), this.template = this.originalSelectorId.replace("#ProductSelect-", ""), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _getCurrentOptions: function() {
            var t = _.map($(this.singleOptionSelector, this.$container), function(t) {
                var e = $(t),
                    a = e.attr("type"),
                    i = {};
                return "radio" === a || "checkbox" === a ? !!e[0].checked && (i.value = e.val(), i.index = e.data("index"), i) : (i.value = e.val(), i.index = e.data("index"), i)
            });
            return t = _.compact(t)
        },
        _getVariantFromOptions: function() {
            var t = this._getCurrentOptions(),
                e = this.product.variants;
            return _.find(e, function(e) {
                return t.every(function(t) {
                    return _.isEqual(e[t.index], t.value)
                })
            })
        },
        _onSelectChange: function() {
            var t = this._getVariantFromOptions();
            this.$container.trigger({
                type: "variantChange",
                variant: t
            }), t && (this.$container.trigger({
                type: "updateVariant",
                variant: t
            }), this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this._updateVariantDetails(t),this._updateVariantFeatures(t), this._updateVariantStock(t),this._updateVariantStockDisplay(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
        },
      
        _updateImages: function(t) {
            if (0 != $(".color_sw.selected .swatch").length) var e = $(".color_sw.selected .swatch").css("background-image").replace("_small_crop_center", "").replace(/(url\(|\)|'|")/gi, "");
            var a = t.featured_media || {},
                i = $(".p-sgl__photos-" + this.template + " .swiper-slide-active").attr("data-src") || {};
            !t.featured_media && void 0 == e || a.src === i && void 0 == e || this.$container.trigger({
                type: "variantImageChange",
                variant: t
            })
        },
        _updatePrice: function(t) {
            t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                type: "variantPriceChange",
                variant: t
            })
        },
        _updateSKU: function(t) {
            t.sku !== this.currentVariant.sku && this.$container.trigger({
                type: "variantSKUChange",
                variant: t
            })
        },

        _updateVariantStockDisplay: function(t) {
            console.log("Updating variant stock display for variant:", t);
            var stockDisplay = $("#variantStockDisplay .sd-items-count p");
        
            if (t.inventory_quantity > 0) {
                stockDisplay.removeClass("out-of-stock").addClass("in-stock");
                stockDisplay.text("Auf Lager ! " + t.inventory_quantity + " Stück verfügbar - Sofort versandfertig, Lieferzeit: 1-2 Werktage.");
            } else {
                stockDisplay.removeClass("in-stock").addClass("out-of-stock");
                stockDisplay.text("Artikel aktuell nicht verfügbar.");
            }
        
            this.$container.trigger({
                type: "variantStockDisplayChange",
                variant: t
            });
        },

        _updateVariantStock: function(t) {
            var currentVariant = _.find(this.product.variants, { id: t.id });
            if (currentVariant) {
                currentVariant.inventory_quantity = t.inventory_quantity;
            }
            
            if (this.currentVariant && this.currentVariant.id && t.id !== this.currentVariant.id) {
                this.$container.trigger({
                    type: "variantStockChange",
                    variant: t
                });
            }
        },

        _updateVariantDetails(currentVariant) {
          const variants = document.querySelectorAll('[data-variant-id]')

          variants.forEach( function(variant) {
            variant.style.display= 'none';
            if(variant.dataset.variantId == currentVariant.id){
              variant.style.display ='block'
            }
          });
        },

        _updateVariantFeatures(currentVariant) {
            $('[data-variant-id]').hide();
            $('[data-variant-id="' + currentVariant.id + '"]').show();
        },
      
        _updateHistoryState: function(t) {
            if (history.replaceState && t) {
                var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                window.history.replaceState({
                    path: e
                }, "", e)
            }
        },
        _updateMasterSelect: function(t) {
            $(this.originalSelectorId, this.$container).val(t.id)
        }
    }), t
}(), theme.Product = function() {
    function t(t) {
        var e = this.$container = $(t),
            a = e.attr("data-section-id");
        e.attr("data-product-id");
        if (theme.ktCountdown(t), this.settings = {
                enableHistoryState: e.data("enable-history-state") || !1,
                imageSize: "720x720",
                sectionId: a,
                zoomEnabled: e.data("use-zoom"),
                thumbEnabled: e.data("use-thumb"),
                imagesLayout: e.data("images-layout"),
                ajaxCart: e.data("enable-ajax-cart") || !1
            }, this.selectors = {
                template: "#ProductSection-" + a,
                addToCart: "#AddToCart-" + a,
                addToCartText: "#AddToCartText-" + a,
                comparePrice: "#ComparePrice-" + a,
                originalPrice: "#ProductPrice-" + a,
                variesPrice: "#ProductVaries-" + a,
                unitPrice: "#UnitPrice-" + a,
                SKU: ".variant-sku",
                originalSelectorId: "#ProductSelect-" + a,
                productPhotosWrapper: ".photos-wrapper-" + a,
                productPhotos: ".p-sgl__photos-" + a,
                productPhotoImages: ".p-sgl__photo--" + a,
                productThumbsWrapper: ".thumbs-wrapper-" + a,
                productThumbs: ".p-sgl__thumbs-" + a,
                productThumbImages: ".p-sgl__thumb--" + a,
                singleOptionSelector: ".sgl-opt-selector-" + a,
                dataSettings: ".datasettings--" + a,
                dataJs: ".datajs--" + a,
                cartForm: "#cart-form--" + a,
                progressBar: ".progress_bar-" + a,
                realTime: ".realTime-" + a,
                dateFromTo: ".prd_delivery-" + a,
                shipBL: ".shipBL-" + a,
                storeAvailabilityContainer: "[data-store-avai-container]",
                variationClean: ".variation-clean--" + a
            }, $("#ProductJson-" + a).html()) {
            this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + a).innerHTML), this.previewImage = _.map(this.productSingleObject.media, "preview_image"), this.modelsObject = JSON.parse(document.getElementById("ModelJson-" + a).innerHTML), this.dataSettings = $(this.selectors.dataSettings).data(), this.dataSettings.progressBar = $(this.selectors.progressBar).length, this.dataSettings.realTime = $(this.selectors.realTime).length, this.dataSettings.dateFromTo = $(this.selectors.dateFromTo).length, this.dataJs = $(this.selectors.dataJs).data(), this.currentMedia = "", this.storeAvailabilityContainer = e.find(this.selectors.storeAvailabilityContainer)[0], this.storeAvailabilityContainer && this._initStoreAvailability();
            var i = this;
            "quickview-template" == a ? setTimeout(function() {
                i._initBreakpoints()
            }, 400) : "masonry" === this.settings.imagesLayout && theme.window_W >= 992 ? ($(i.selectors.productThumbImages).length >= 1 && $(i.selectors.productThumbsWrapper + ":not(.first)").addClass("has-its"), $(i.selectors.productPhotoImages).length >= 1 && $(i.selectors.productPhotosWrapper + ":not(.first)").addClass("has-its"), this._initIsotope(), i._initPhotoSwipeFromDOM(), i._initPhotoZoom()) : "list" === this.settings.imagesLayout && theme.window_W >= 992 ? ($(i.selectors.productThumbImages).length >= 1 && $(i.selectors.productThumbsWrapper + ":not(.first)").addClass("has-its"), $(i.selectors.productPhotoImages).length >= 1 && $(i.selectors.productPhotosWrapper + ":not(.first)").addClass("has-its"), i._initPhotoSwipeFromDOM(), i._initPhotoZoom()) : this._initBreakpoints(), this._stringOverrides(), this._initVariants(), this._initImageSwitch(), this._initSwatch(), this.dataJs.imgspos360.length > 0 && this._create360(), this.dataSettings.useMaxheight && $(i.selectors.template + " iframe#resize-image-product").length > 0 && this._onReSizeImages(), this.dataSettings.stickyatc && this._stickyAddCart(), this._AjaxForm(), this.dataSettings.progressBar && this._stockCountdown().init(this.selectors.progressBar), this.dataSettings.realTime && this._realTimeVisitor(this.selectors.realTime), this.dataSettings.dateFromTo && this._dateFromTo(this.selectors.dateFromTo), $(i.selectors.template + " .table-products").length > 0 && this._responTableGroup(), this.variants.currentVariant.featured_media && this.variants.currentVariant.featured_media.preview_image && (this.currentMedia = this.variants.currentVariant.featured_media.preview_image)
        }
    }
    return $(document).on("click", ".fake_select label", function(t) {
        t.preventDefault();
        var e = $(this).parents(".fake_select");
        e.toggleClass("show"), $(".fake_select.show").not(e).removeClass("show")
    }).on("click", function(t) {
        !1 === $(t.target).is(".fake_select.show") && !1 === $(t.target).is(".fake_select.show *") && $(".fake_select").removeClass("show")
    }).on("click", ".btn.play", function(t) {
        $(this).closest(".product-page").find("video.video-element").trigger("play")
    }), t.prototype = _.assignIn({}, t.prototype, {
        _stringOverrides: function() {
            theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
        },
        _initStoreAvailability: function() {
            this.storeAvailability = new theme.StoreAvailability(this.storeAvailabilityContainer)
        },
        _initBreakpoints: function() {
            var t = this,
                e = theme.window_W;
            KT.loadScript("swiper", function(a, i) {
                "ok" == i && ($(t.selectors.productThumbImages).length >= 1 && t._initThumbnailSlider(), $(t.selectors.productPhotoImages).length >= 1 && t._initPhotoSlider(), $(window).on("resize", function() {
                    (e >= 576 && theme.window_W < 576 || e < 576 && theme.window_W >= 576) && (t.dataSettings.useThumbVertical && ("object" == typeof t.thumbSlider ? t.thumbSlider.changeDirection() : $(t.selectors.productThumbImages).length >= 1 && t._initThumbnailSlider()), e = theme.window_W)
                }))
            })
        },
        _initIsotope: function() {
            var t = this;
            KT.loadScript("isotope", function(e, a) {
                if ("ok" == a) {
                    var i = $(t.selectors.productPhotos).isotope({
                        initLayout: !1,
                        itemSelector: ".p-sgl__photos-item",
                        percentPosition: !0,
                        masonry: {
                            columnWidth: ".grid-sizer"
                        }
                    });
                    i.one("arrangeComplete", function() {
                        t._mediaSlider(!1)
                    }), i.isotope(), i.on("removeComplete", function() {
                        t._mediaSlider(!1)
                    })
                }
            })
        },

        _initSwatch: function() {
            var t = this;
            $(t.$container).on("change", ".--js-select", function(e) {
                var a = $(this);
                goto = !0, optionIndex = a.parents(".--js-selector").data("js-opt"), optionValue = a.val();
                var i = t.selectors.template + ' .--js-selector[data-js-opt="' + optionIndex + '"]',
                    o = $(i);
                 $(i + " .--js-opt").removeClass("selected");
                  o.find(".fake_select.variant_image").length && (
                      o.find(".fake_select.variant_image li").removeClass("selected"),
                      o.find('.fake_select.variant_image li[data-value="' + escape(optionValue) + '"]').addClass("selected")
                  );
                  $(".fake_select.show").removeClass("show");
                  o.removeClass("op_pre_select error");
                  $(t.selectors.cartForm + " #SglOptSelector-" + optionIndex).val(optionValue).trigger("change");
                  $(".kt-stickyAddCart .swatch-on-grid._" + _snakeCase(optionValue) + " .swatch").trigger("click");
                  ;}),
              $(t.$container).on("click", ".--js-opt", function(e) {
                e.preventDefault();
                var a = $(this);
                goto = !0, optionIndex = a.parents(".--js-selector").data("js-opt"), optionValue = a.data("value");
                var i = t.selectors.template + ' .--js-selector[data-js-opt="' + optionIndex + '"]',
                    o = $(i);
                $(i + " .--js-opt").removeClass("selected"), a.addClass("selected"), o.find(".fake_select.variant_image").length && (o.find(".fake_select.variant_image li").removeClass("selected"), o.find('.fake_select.variant_image li[data-value="' + optionValue + '"]').addClass("selected")), $(".fake_select.show").removeClass("show"), o.removeClass("op_pre_select error"), $(t.selectors.cartForm + " #SglOptSelector-" + optionIndex).val(optionValue).trigger("change"), $(".kt-stickyAddCart .swatch-on-grid._" + _snakeCase(optionValue) + " .swatch").trigger("click")
            })
        },
        _initVariants: function() {
            var t = this,
                e = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
            if (_.filter(theme.function.productOptionStyle, {
                    op_pre_select: !0
                }).length && (e.enableHistoryState = !1), this.variants = new slate.Variants(e), this.storeAvailability && this.variants.currentVariant.available && this.storeAvailability.updateContent(this.variants.currentVariant.id), this.$container.on("variantChange", this._updateAddToCart.bind(this)), this.$container.on("variantImageChange", this._updateImages.bind(this)), this.$container.on("variantPriceChange", this._updatePrice.bind(this)), this.$container.on("variantSKUChange", this._updateSKU.bind(this)), !this.dataJs.dfVariant) {
                this.dataJs.dfVariant = !0;
                var a = this.variants.currentVariant.option1,
                    i = 0,
                    o = "SglOptSelector-0--" + t.settings.sectionId,
                    s = "SglOptSelector-1--" + t.settings.sectionId,
                    r = "SglOptSelector-2--" + t.settings.sectionId,
                    n = void 0,
                    l = void 0;
                _.forEach(t.productSingleObject.options, function(e, a) {
                    void 0 === (n = _.find(theme.function.productOptionStyle, {
                        name: e
                    })) || 1 != n.color_watched || (l = "SglOptSelector-" + a++ +"--" + t.settings.sectionId)
                }), _.forEach(t.productSingleObject.variants, function(e) {
                    $.each($("#" + o + " option"), function(a, i) {
                        $(this).val() == e.option1 && void 0 == $(this).attr("data-first-variant") && $(this).attr({
                            "data-first-variant": $(t.selectors.originalSelectorId + ' option[value="' + e.id + '"]').data("value")
                        })
                    }), $.each($("#" + l + " option"), function(t, o) {
                        var n = e.option1;
                        l === s ? n = e.option2 : l === r && (n = e.option3), n !== a && (i = 0, a = n), 0 == i && $(this).val() == n && (e.featured_image && $(this).attr("data-featured-image", e.featured_image.src), i++)
                    })
                }), $.each($(".sgl-opt-selector-" + t.settings.sectionId), function(e, a) {
                    var i = $(this),
                        o = $('.--js-selector[data-js-opt="' + i.data("js-selector") + '"]').first(),
                        s = _.find(theme.function.productOptionStyle, {
                            name: o.data("n-opt")
                        });
                    void 0 !== s && ("combobox with_out_variant_image" === s.style || s.color_watched && "color" !== t.dataSettings.swatchStyle) && $.each(o.find(".--js-opt"), function(e, a) {
                        var r = $(this);
                        if (void 0 !== (l = i.find('option[value="' + r.attr("data-value") + '"]').attr("data-featured-image")))
                            if ("combobox with_out_variant_image" === s.style) {
                                var n = _.last(l.split(".")),
                                    l = l.replace("." + n, "_150x150_crop_center." + n);
                                $('[data-n-opt="' + o.data("n-opt") + '"] .--js-opt[data-value="' + r.attr("data-value") + '"]').find("img").attr("data-src", l).addClass("lazyload")
                            } else if (s.color_watched && "color" !== t.dataSettings.swatchStyle) {
                            var n = _.last(l.split(".")),
                                l = l.replace("." + n, "_100x100." + n);
                            $('[data-n-opt="' + o.data("n-opt") + '"] .--js-opt[data-value="' + r.attr("data-value") + '"]').find(".swatch").css({
                                "background-image": 'url("' + l + '")',
                                "background-color": "transparent"
                            })
                        }
                    })
                }), this._initVariant(this.variants.currentVariant), this.$container.on("updateVariant", this._updateVariant.bind(this))
            }
            $(document).on("click", this.selectors.variationClean, function(e) {
                e.preventDefault(), $(this).hide(), $("[data-op-pre-select]").each(function(e, a) {
                    let i = $(this);
                    i.addClass("op_pre_select"), $(t.selectors.originalSelectorId).data("name_opt") ? i.find(".js-change-label").html(theme.productStrings.label_select_opt) : i.find(".js-change-label").html(theme.productStrings.label_select + i.attr("data-n-opt").toLowerCase()), i.find(".--js-opt.selected").removeClass("selected"), i.find(".--js-select").val("")
                }), void 0 !== t.photoSlider && t.photoSlider.slideTo(0, 300, !1)
            }), $(document).on("click", "img.zoomImg", function(e) {
                e.preventDefault(), $(t.selectors.template + ' img[data-srcfix="' + theme.Images.removeProtocol(e.target.currentSrc) + '"]').trigger("click")
            }), $(document).on("touchstart", ".pswp__bg", t => {
                t.preventDefault()
            })
        },
        _AjaxForm: function() {
            var t = this,
                e = $(t.selectors.cartForm),
                a = new Array;
            $(document).on("change", ".group-product .product-form__variants", function() {
                var t = $(this).parents(".itemGroupProducts"),
                    e = $(this).find("option:selected"),
                    a = parseInt(e.attr("data-price")),
                    i = parseInt(e.attr("data-c-price"));
                t.find('[name="qty_group"]').attr({
                    "data-id": $(this).val(),
                    "data-price": a,
                    "data-c-price": i
                }), t.find(".price ins").html(formatMoney_(a)), a !== i ? t.find(".price del").html(formatMoney_(i)).removeClass("d-none") : t.find(".price del").addClass("d-none")
            }), e.on("change", function(i) {
                i.preventDefault();
                var o = e.find('[name="qty_group"]').length,
                    s = t.variants.currentVariant.price,
                    r = t.variants.currentVariant.compare_at_price || 0;
                t.$container.hasClass("product-mix-a-match") && (s = 0, r = 0), o !== (a = _.filter($(this).serializeArray(), {
                    name: "qty_group",
                    value: "0"
                })).length ? ($.each(e.find('[name="qty_group"]'), function(t, e) {
                    var a = $(this).val(),
                        i = parseInt($(this).attr("data-price")),
                        o = parseInt($(this).attr("data-c-price"));
                    s += i * a, r += o * a
                }), $(".subtt_gr--" + t.settings.sectionId + " .subtt_gr-money").html(formatMoney_(s)), s !== r ? $(".subtt_gr--" + t.settings.sectionId + " .subtt_gr-c-money").html(formatMoney_(r)).removeClass("d-none") : $(".subtt_gr--" + t.settings.sectionId + " .subtt_gr-c-money").addClass("d-none"), e.addClass("may-add"), $(".subtt_gr--" + t.settings.sectionId).show()) : (e.removeClass("may-add"), $(".subtt_gr--" + t.settings.sectionId).hide())
            }), this.settings.ajaxCart ? $(document).on("submit", t.selectors.cartForm, function(a) {
                if (a.preventDefault(), $(t.selectors.addToCart).removeClass("loaded").addClass("loading"), $(t.selectors.template).find(".op_pre_select").length > 0) return $(t.selectors.template).find(".op_pre_select").addClass("error flash"), setTimeout(function() {
                    $(t.selectors.template).find(".op_pre_select").removeClass("flash")
                }, 1e3), $(".btn.loading").removeClass("loading"), !1;
                if (e.find(".itemGroupProducts").length > 0) {
                    var i = [];
                    e.find('[name="quantity"]').length > 0 && i.push({
                        id: parseInt(e.find('[name="id"]').val()),
                        quantity: parseInt(e.find('[name="quantity"]').val())
                    }), $(t.selectors.cartForm + ' .itemGroupProducts [name="qty_group"]').each(function() {
                        i.push({
                            id: parseInt($(this).attr("data-id")),
                            quantity: parseInt($(this).val(), 10) || 0
                        })
                    }), Shopify.KT_addItems(i)
                } else Shopify.KT_addItemFromForm("cart-form--" + t.settings.sectionId)
            }) : 0 == this.settings.ajaxCart && $(document).on("submit", t.selectors.cartForm, function(a) {
                if ($(t.selectors.addToCart).removeClass("loaded").addClass("loading"), $(t.selectors.template).find(".op_pre_select").length > 0) return a.preventDefault(), $(t.selectors.template).find(".op_pre_select").addClass("error flash"), setTimeout(function() {
                    $(t.selectors.template).find(".op_pre_select").removeClass("flash")
                }, 1e3), $(".btn.loading").removeClass("loading"), !1;
                if (e.find(".itemGroupProducts").length > 0) {
                    a.preventDefault();
                    var i = [];
                    e.find('[name="quantity"]').length > 0 && i.push({
                        id: parseInt(e.find('[name="id"]').val()),
                        quantity: parseInt(e.find('[name="quantity"]').val())
                    }), $(t.selectors.cartForm + ' .itemGroupProducts [name="qty_group"]').each(function() {
                        i.push({
                            id: parseInt($(this).attr("data-id")),
                            quantity: parseInt($(this).val(), 10) || 0
                        })
                    });
                    var o = {
                        type: "POST",
                        url: Shopify.root_url + "/cart/add.js",
                        data: {
                            items: i
                        },
                        dataType: "json",
                        success: function(t) {
                            window.location.href = Shopify.root_url + "/cart"
                        },
                        error: function(t) {
                            alert("error")
                        }
                    };
                    $.ajax(o)
                }
            })
        },
        _initVariant: function(t) {
            var e = this,
                a = new Array,
                i = new Array,
                o = (t.option1, e.settings.sectionId, "SglOptSelector-1--" + e.settings.sectionId),
                s = "SglOptSelector-2--" + e.settings.sectionId;
            $.each($(".sgl-opt-selector-" + e.settings.sectionId + " option"), function(t, e) {
                $(this).text($(this).val())
            }), $("._soulout").removeClass("_soulout"), $("._unavailable").removeClass("_unavailable"), $(".kt_flash_lable").text(""), _.forEach(e.productSingleObject.variants, function(r) {
                r.option1 === t.option1 && (a.push(r.option2), r.option2 === t.option2 && i.push(r.option3)), 0 == r.available && (r.option1 == t.option1 && r.option2 == t.option2 ? $.each($("#" + s + " option"), function(t, a) {
                    r.option3 != $(this).attr("value") && $.each($('[data-js-opt="2--' + e.settings.sectionId + '"] .--js-opt'), function(t, e) {
                        $(e).attr("data-value") == r.option3 && $(e).addClass("_soulout")
                    })
                }) : r.option1 == t.option1 && r.option3 == t.option3 && $.each($("#" + o + " option"), function(t, a) {
                    r.option2 != $(this).attr("value") && $.each($('[data-js-opt="1--' + e.settings.sectionId + '"] .--js-opt'), function(t, e) {
                        $(e).attr("data-value") == r.option2 && $(e).addClass("_soulout")
                    })
                }))
            }), a = $.unique(a), i = $.unique(i), $.each($("#" + o + " option"), function(i, o) {
                if (-1 == _.indexOf(a, $(this).attr("value"))) $.each($('[data-js-opt="1--' + e.settings.sectionId + '"] .--js-opt'), function(t, e) {
                    $(e).attr("data-value") == $(o).val() && $(e).addClass("_unavailable").find(".kt_flash_lable").text(" - Unavailable")
                });
                else if ("color" !== e.dataSettings.swatchStyle) {
                    var s = _.filter(e.productSingleObject.variants, {
                        option1: t.option1,
                        option2: $(this).attr("value"),
                        option3: t.option3
                    });
                    if (void 0 !== (n = null !== s[0].featured_image ? s[0].featured_image.src : void 0)) {
                        var r = _.last(n.split(".")),
                            n = n.replace("." + r, "_100x100_crop_center." + r);
                        $('[data-js-opt="1--' + e.settings.sectionId + '"] [data-value="' + escape($(this).val()) + '"] .swatch').css("background-image", 'url("' + n + '")')
                    }
                }
            }), $.each($("#" + s + " option"), function(a, o) {
                if (-1 == _.indexOf(i, $(this).attr("value"))) $('[data-js-opt="2--' + e.settings.sectionId + '"] [data-value="' + escape($(this).val()) + '"]').addClass("_unavailable").find(".kt_flash_lable").text(" - Unavailable");
                else if ("color" !== e.dataSettings.swatchStyle) {
                    var s = _.filter(e.productSingleObject.variants, {
                        id: t.id
                    });
                    if (void 0 !== (n = null !== s[0].featured_image ? s[0].featured_image.src : void 0)) {
                        var r = _.last(n.split(".")),
                            n = n.replace("." + r, "_100x100_crop_center." + r);
                        $('[data-js-opt="2--' + e.settings.sectionId + '"] [data-value="' + escape($(this).val()) + '"] .swatch').css("background-image", 'url("' + n + '")')
                    }
                }
            })
        },
        _initImageSwitch: function() {
            if ($(this.selectors.productThumbImages).length) {
                var t = this;
                $(t.$container).on("click", this.selectors.productThumbImages, function(e) {
                    e.preventDefault();
                    var a = $(this),
                        i = t.selectors.template;
                    if (void 0 !== a.attr("data-id") && "" !== a.attr("data-id")) {
                        var o = _.filter(t.productSingleObject.variants, function(t) {
                            if (t.featured_image && t.featured_image.variant_ids.includes(parseInt(a.attr("data-id")))) return t
                        });
                        if (o.length > 1) $(i + ' .--js-opt[data-value="' + o[0].option1 + '"]').first().trigger("click");
                        else {
                            goto = !1, $(i + " .fake_select li").removeClass("selected"), $(o[0].options).each(function(e, a) {
                                var s = $(i + ' option[value="' + a + '"]').val(),
                                    r = $(i + ' option[value="' + a + '"]').parent();
                                $(i + " .fake_select li._" + t.productSingleObject.more_variants[o[0].id].options_handle[e]).addClass("selected"), a != t.productSingleObject.title && !1 === $('[data-js-opt="' + e + "--" + t.settings.sectionId + '"]').hasClass("op_pre_select") && $(i + ' label[data-change-label="SglOptSelector-' + e + "--" + t.settings.sectionId + '"] .js-change-label').text(a), s != r.val() && r.val(s).trigger("change")
                            });
                            var s = a.attr("data-id");
                            if (1 == $(this).parents("div.product-page").data("enable-history-state") && _.filter(theme.function.productOptionStyle, {
                                    op_pre_select: !0
                                }).length <= 0) {
                                var r = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + s;
                                window.history.replaceState({
                                    path: r
                                }, "", r)
                            }
                        }
                    }
                })
            }
        },
        _initThumbnailSlider: function() {
            var t = this,
                e = $(window).width();
            if ($(t.selectors.productThumbsWrapper + ":not(.first)").addClass("has-its"), t.thumbnailOptions) a = t.thumbnailOptions;
            else {
                var a = $(t.selectors.productThumbsWrapper).data();
                a.speed = 500, a.grabCursor = !0, a.watchOverflow = !0, a.initialSlide = initialSlide || 0, t.dataSettings.useThumbVertical && e >= 576 && (a.direction = "vertical", a.slidesPerView = "auto"), t.thumbnailOptions = a
            }
            t.thumbSlider = new Swiper(t.selectors.productThumbsWrapper, a)
        },
        _destroyThumbnailSlider: function() {
            this.thumbSlider.destroy(), this.thumbSlider = void 0, this.thumbnailOptions = void 0
        },
        _initPhotoSlider: function() {
            var t = this;
            $(t.selectors.productPhotosWrapper).addClass("has-its");
            var e = $(t.selectors.template + " .product-detail-image .btn-group");
            if (t.itsVisible = !1, t.photoOptions) a = t.photoOptions;
            else {
                var a = $(t.selectors.productPhotosWrapper).data();
                if (a.speed = 500, a.grabCursor = !0, a.watchOverflow = !0, a.initialSlide = initialSlide || 0, a.navigation = {
                        nextEl: ".sw-btn-next-" + t.settings.sectionId,
                        prevEl: ".sw-btn-prev-" + t.settings.sectionId
                    }, a.pagination = {
                        el: ".swiper-pagination-" + t.settings.sectionId,
                        type: "bullets"
                    }, "creative" == a.effect) {
                    var i = "rtl" == themeAlign ? "50%" : "-50%";
                    a.creativeEffect = {
                        prev: {
                            translate: [i, 0, -500]
                        },
                        next: {
                            translate: ["0%", 0, -500]
                        }
                    }
                }!1 === $(t.selectors.productThumbsWrapper).hasClass("oneImageThumb") && (a.thumbs = {
                    swiper: t.thumbSlider
                }, theme.function.use_thumb_hidden_on_mb && theme.window_W < 768 && (a.thumbs = null)), t.productSingleObject.media.length > t.productSingleObject.images.length && (a.simulateTouch = !1), a.on = {
                    init: function(a) {
                        initialSlide = 0;
                        var i = !0,
                            o = $(a.slides[a.activeIndex]);
                        if ((o.find("video").length <= 0 || o.find(".bgndVideo").length <= 0) && (i = !1), t._mediaSlider(i), t._initPhotoSwipeFromDOM(), t._initPhotoZoom(), e.length > 0) {
                            e.css("z-index", "-1");
                            for (var s = a.activeIndex; s < a.activeIndex + a.visibleSlidesIndexes.length; s++)
                                if ($(a.slides[s]).hasClass("gallery-image")) return e.css("z-index", "1"), !0
                        }
                    },
                    slideChange: function(a) {
                        if (t.itsVisible || ($(t.selectors.productPhotosWrapper).addClass("its-visible"), t.itsVisible = !0), a.thumbs.swiper) {
                            var i = a.thumbs.swiper,
                                o = a.activeIndex,
                                s = i.slides.length;
                            i.visibleSlidesIndexes && (o === i.visibleSlidesIndexes[i.visibleSlidesIndexes.length - 1] && o < s && t.thumbSlider.translateTo(-1 * i.snapGrid[i.visibleSlidesIndexes[1]], 300, !1), o === i.visibleSlidesIndexes[0] && 0 !== o && t.thumbSlider.translateTo(-1 * i.snapGrid[i.visibleSlidesIndexes[0] - 1], 300, !1))
                        }
                        "function" == typeof jQuery.fn.YTPlayer && $.each($(t.selectors.productPhotosWrapper + " .bgndVideo"), function() {
                            $(this).YTPPause()
                        }), $.each($(t.selectors.productPhotosWrapper + " video"), function() {
                            $(this).trigger("pause")
                        });
                        var r = $(a.slides[a.activeIndex]);
                        if (r.find(".lazyloading:not(.lazyload)").addClass("lazyload"), r.find(".plyr__video-wrapper video").length > 0 ? $(r).find("video").trigger("play") : r.find(".bgndVideo.mb_YTPlayer").length > 0 ? r.find(".bgndVideo.mb_YTPlayer").YTPPlay() : r.find("model-viewer").length > 0 && (r.find("model-viewer").trigger("click"), $(t.selectors.template + " .view-in-space").attr("data-shopify-model3d-id", r.find("model-viewer").attr("data-model-id"))), 0 == theme.is_mobile && t.settings.zoomEnabled && "function" == typeof $.fn.zoom && ($(t.selectors.template + " .photos-wrapper .p-sgl__photos-item").trigger("zoom.destroy"), $.each($(t.selectors.template + " .photos-wrapper .gallery-image.swiper-slide-visible"), function(t, e) {
                                $(this).zoom({
                                    url: $(this).attr("data-src")
                                })
                            })), e.length > 0) {
                            e.css("z-index", "-1");
                            for (var n = a.activeIndex; n < a.activeIndex + a.visibleSlidesIndexes.length; n++)
                                if ($(a.slides[n]).hasClass("gallery-image")) return e.css("z-index", "1"), !0
                        }
                    }
                }, t.photoOptions = a
            }
            t.photoSlider = new Swiper(t.selectors.productPhotosWrapper + ":not(.first)", a)
        },
        _mediaSlider: function(t) {
            var e = this;
            return $(e.selectors.productPhotosWrapper + " .plyr__video-wrapper video").length > 0 || ($(e.selectors.productPhotosWrapper + " .bgndVideo.mb_YTPlayer").length > 0 || ($(e.selectors.productPhotosWrapper + " .shopify-model-viewer-ui").length > 0 || (e.dataSettings.video5 && (KT.loadScript("plyr", function(a, i) {
                "ok" == i && $.each($(e.selectors.productPhotosWrapper + ":not(.first) video"), function(e, a) {
                    new Shopify.Plyr($(this), {
                        loop: {
                            active: !0
                        },
                        autoplay: t
                    })
                })
            }), t = !1), e.dataSettings.externalVideo && (KT.loadScript("YTPlayer", function(a, i) {
                "ok" == i && $.each($(e.selectors.productPhotosWrapper + ":not(.first) .bgndVideo"), function(e, a) {
                    $(this).YTPlayer({
                        autoPlay: t
                    })
                })
            }), t = !1), void(e.dataSettings.model && (KT.loadScript("shopify-xr", function(t, a) {
                "ok" == a && (ShopifyXR.addModels(e.modelsObject), ShopifyXR.setupXRElements())
            }), KT.loadScript("model-viewer-ui", function(t, a) {
                "ok" == a && $.each($(e.selectors.productPhotosWrapper + ":not(.first) model-viewer"), function(t, e) {
                    new Shopify.ModelViewerUI(this)
                })
            }))))))
        },
        _destroyPhotoSlider: function() {
            this.photoSlider.destroy(), this.photoSlider = void 0, this.photoOptions = void 0
        },
        _updateVariant: function(t) {
            var e = t.variant,
                a = this.dataJs;
            if ($(".prd-mirror-" + this.productSingleObject.id).length > 0 && $(".prd-mirror-" + this.productSingleObject.id).val(e.id).trigger("change"), this._initVariant(e), $(this.selectors.variationClean).show(), null != e.featured_media && void 0 != e.featured_media && this.dataSettings.gallery && a.curpos.join(",") != a.imgspos) {
                if (this.currentMedia.src == e.featured_media.preview_image.src) return;
                this.currentMedia = e.featured_media.preview_image, this._updateGallery(e)
            }
        },
        _updateAddToCart: function(t) {
            var e = t.variant,
                a = this,
                i = a.selectors.template,
                o = a.settings.sectionId;
            if (e) {
                this.storeAvailability && this.storeAvailability.updateContent(t.variant.id), $(i + ' .notify-available [name="contact[body]"]').length > 0 && $(i + ' .notify-available [name="contact[body]"]').val($(i + ' .notify-available [name="contact[body]"]').val().replace(/\(.*\)/g, "(" + e.title + ")"));
                var s = $(i + ' option[value="' + e.id + '"]');
                e.inventory_quantity = parseInt(s.data("inventory-quantity")), e.incoming = s.data("incoming"), void 0 !== $("#SglOptSelector-0--" + o) && 0 == $('[data-js-opt="0--' + o + '"]').hasClass("op_pre_select") && ($('label[data-change-label="0--' + o + '"] .js-change-label').html($("#SglOptSelector-0--" + o).val()), $('.--js-select[data-js-opt="0--' + o + '"]').val($("#SglOptSelector-0--" + o).val())), void 0 !== $("#SglOptSelector-1--" + o) && 0 == $('[data-js-opt="1--' + o + '"]').hasClass("op_pre_select") && ($('label[data-change-label="1--' + o + '"] .js-change-label').html($("#SglOptSelector-1--" + o).val()), $('.--js-select[data-js-opt="1--' + o + '"]').val($("#SglOptSelector-1--" + o).val())), void 0 !== $("#SglOptSelector-2--" + o) && 0 == $('[data-js-opt="2--' + o + '"]').hasClass("op_pre_select") && ($('label[data-change-label="2--' + o + '"] .js-change-label').html($("#SglOptSelector-2--" + o).val()), $('.--js-select[data-js-opt="2--' + o + '"]').val($("#SglOptSelector-2--" + o).val())), $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true"), e.available ? ($(i).find(".kt_progress_bar").slideDown(), $(".fbt-item #ip_" + a.productSingleObject.id + ":not(:checked)").removeAttr("disabled").trigger("click").attr("disabled", "disabled"), $(".notify-" + a.productSingleObject.id).slideUp(), e.inventory_quantity > 0 && null !== e.inventory_management && ($("#qty-" + o).attr("max", e.inventory_quantity).trigger("change"), this.dataSettings.progressBar && ($(a.selectors.progressBar).attr("data-remaining_items", e.inventory_quantity), a._stockCountdown().updateMeter(a.selectors.progressBar, e.inventory_quantity, !0)))) : ($(".notify-" + a.productSingleObject.id).slideDown(), $(".fbt-item #ip_" + a.productSingleObject.id + ":checked").removeAttr("disabled").trigger("click").attr("disabled", "disabled"), $(i).find(".kt_progress_bar").slideUp()), e.available || e.incoming ? ($(this.selectors.addToCart).prop("disabled", !1), e.inventory_quantity <= 0 && "shopify" === e.inventory_management && e.incoming || !e.inventory_quantity && e.incoming ? ($(".preOrder--" + o).slideDown().find("span").html(e.incoming), $(this.selectors.addToCartText).text(theme.strings.preOrder)) : ($(".preOrder--" + o).slideUp(), $(this.selectors.addToCartText).text(theme.strings.addToCart)), $(i).find(".shopifyPaymentButton").show()) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut), $(i).find(".shopifyPaymentButton").hide())
            } else if (1 == goto) {
                $("#SglOptSelector-0--" + o).val();
                var r = $("#SglOptSelector-0--" + o + " option:selected").attr("data-first-variant").split(" / ");
                $("#SglOptSelector-1--" + o + " .fake_select .--js-opt, #SglOptSelector-2--" + o + " .fake_select .--js-opt").removeClass("selected");
                for (var n = "", l = 0; l <= r.length - 1; l++) {
                    $.each($("#SglOptSelector-" + l + "--" + o + " option"), function(t, e) {
                        if ($(this).val() == r[l]) return n = $(this).val(), !1
                    }), $.each($("#SglOptSelector-" + l + "--" + o + " .fake_select .--js-opt"), function(t, e) {
                        if ($(this).attr("data-value") == r[ii]) return $(this).addClass("selected"), !1
                    });
                    var d = $("#SglOptSelector-" + l + "--" + o);
                    $('label[data-change-label="' + l + "--" + o + '"] .js-change-label').html(r[l]), n != d.val() && d.val(n).change()
                }
            }
        },
        _updateImages: function(t) {
            var e = this,
                a = t.variant;
            if (void 0 != a.featured_media) {
                var i = a.featured_media.preview_image.src;
                if (void 0 != i && 1 == goto) {
                    var o = $(this.selectors.productPhotos + ' .p-sgl__photos-item[data-src="' + theme.Images.removeProtocol(i) + '"]');
                    slideIndex = o.index(), void 0 !== e.photoSlider && e.photoSlider.slideTo(slideIndex, 300, !1)
                }
            }
        },
        _updateGallery: function(t) {
            var e = this,
                a = this.dataJs,
                i = t.featured_media ? _.indexOf(_.map(e.previewImage, "src"), t.featured_media.preview_image.src) + 1 : parseInt($(this.selectors.dataJs).attr("data-vrimgpos")),
                o = a.imgspos.split(","),
                s = _.map(e.previewImage, "src"),
                r = "";
            if ($(e.selectors.productThumbImages).length >= 1) var n = "";
            var l = $(this.selectors.dataJs).attr("data-vrimgpos");
            if (-1 == _.indexOf(o, i.toString()) && l == i.toString()) return !0;
            var d = [];
            _.forEach(o, function(t, e) {
                if (parseInt(t) >= i) return parseInt(t) == s.length ? (d.push(parseInt(o[e])), d.push(parseInt(t)), !1) : (d.push(parseInt(t)), d.push(parseInt(o[e + 1])), !1)
            });
            var c = !1;
            if ($.unique($.merge(JSON.parse($(this.selectors.dataJs).attr("data-curpos")), d)).length > 2 && (c = !0), parseInt(d[0]) == parseInt(d[1]) && (c = !0), o.length <= 0 && !c) return !0;
            $(this.selectors.dataJs).attr("data-curpos", "[" + d[0] + "," + d[1] + "]"), $(this.selectors.dataJs).attr("data-vrimgpos", i);
            _.map(e.previewImage, "width"), _.map(e.previewImage, "height");
            if ($(this.selectors.productThumbs).length > 0) var p = theme.Images.imageSize($(this.selectors.productThumbs + " .p-sgl__thumb-image:first").attr("src")) || theme.Images.imageSize($(this.selectors.productThumbs + " .p-sgl__thumb-image:first").attr("data-src"));
            var h = positionIdx = 0,
                u = !1;
            if ("normal" === theme.function.productImgType) {
                var m = e.productSingleObject.media[0].preview_image;
                m.width, m.height
            }
            _.forEach(e.productSingleObject.media, function(t, a) {
                if (parseInt(d[1]) < a + 1) return !0;
                if (u = !1, parseInt(d[0]) <= a + 1 && parseInt(d[1]) > a + 1 && (u = !0), parseInt(d[0]) == parseInt(d[1]) && parseInt(d[0] == a + 1) && (u = !0), parseInt(d[0]) == parseInt(d[1]) && parseInt(d[0]) == a + 1 && parseInt(d[1]) == s.length && (u = !0), o[o.length - 2] !== o[o.length - 1] && parseInt(d[1]) == a + 1 && parseInt(d[1]) == s.length && (u = !0), 1 == u) {
                    var i = _.last(t.preview_image.src.split(".")),
                        l = t.preview_image.src.replace("." + i, "_{width}x." + i);
                    if ($(e.selectors.productThumbs).length > 0) var c = t.preview_image.src.replace("." + i, "_" + p + "." + i);
                    var m = _.filter(e.productSingleObject.variants, function(e) {
                            if (e.featured_media && e.featured_media.preview_image.src == t.preview_image.src) return e
                        }),
                        g = "stretch" === theme.function.productImgType ? " is-cover" : "",
                        f = " one_hundred";
                    if (0 !== h) {
                        4 == positionIdx && (positionIdx = 0), f = [" forty", " sixties", " sixties", " forty"][positionIdx], positionIdx++
                    }
                    var v = m.length > 0 ? ' title="' + m[0].title + '"' : "",
                        b = m.length > 0 ? ' data-id="' + m[0].id + '"' : "";
                    switch (r += '<div class="swiper-slide p-sgl__photos-item  gallery-' + t.media_type + g + f + '" data-src="' + theme.Images.removeProtocol(t.preview_image.src) + '">', r += '<div class="p-sgl__photo p-sgl__photo-' + a + " p-sgl__photo--" + e.settings.sectionId + ' aspectRatio" data-src="' + theme.Images.removeProtocol(t.preview_image.src) + '"' + v + b + ' style="--ar-i: ' + 1 / t.aspect_ratio * 100 + '%">', "external_video" !== t.media_type && (r += '<img width="' + t.preview_image.width + '" height="' + t.preview_image.height + '" class="p-sgl__photo-image lazyload"', r += ' src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="', r += ' data-src="' + l + '" data-widths="[335, 550, 700, 850, 900]"', r += ' data-aspectratio="' + t.preview_image.width / t.preview_image.height + '"', r += ' data-srcfix="' + theme.Images.removeProtocol(t.preview_image.src) + '"', "image" === t.media_type && (r += ' data-size="' + t.preview_image.width + "x" + t.preview_image.height + '"'), r += ' data-sizes="auto">'), t.media_type) {
                        case "external_video":
                            r += '<div class="video_content video_content_' + t.id + ' embed-responsive embed-responsive-16by9">', r += '<div class="position-absolute" style="top: 0;left: 0;width: 100%;height: 100%;">', r += '<div class="position-relative" style="width: 100%;height: 100%;">', "youtube" == t.host ? r += '<div class="bgndVideo" data-property="{videoURL:\'https://www.youtube.com/watch?v=' + t.external_id + "', quality:'highres', stopMovieOnBlur: false, containment: 'self', vol: 100}\"></div>" : r += '<iframe src="https://player.vimeo.com/video/' + t.external_id + '?autoplay=1&loop=1&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>', r += "</div>", r += "</div>", r += "</div>";
                            break;
                        case "video":
                            r += '<div class="video_content video_content_' + t.id + '">', r += '<video playsinline="playsinline" controls="controls" loop="loop" preload="none" class="video-element" aria-label="' + e.productSingleObject.title + '" poster="' + t.preview_image.src.replace("." + i, "_720x." + i) + '">', $.each(t.sources, function(t, e) {
                                r += '<source src="' + e.url + '" type="' + e.mime_type + '">'
                            }), r += '<img src="' + theme.Images.removeProtocol(t.preview_image.src.replace("." + i, "_720x." + i)) + '">', r += "</video>", r += "</div>";
                            break;
                        case "model":
                            r += '<div class="video_content model_content model_content_' + t.id + '">', r += '<model-viewer reveal="interaction" toggleable="true" data-model-id="' + t.id + '" src="' + t.sources[0].url + '" camera-controls="true" data-shopify-feature="0.8" alt="' + e.productSingleObject.title + '" poster="' + t.preview_image.src.replace("." + i, "_720x." + i) + '"></model-viewer>', r += "</div>"
                    }
                    if ("normal" === theme.function.productImgType && "masonry" === e.settings.imagesLayout && (r += '<style media="(min-width: 992px)">.product-page .aspectRatio.p-sgl__photo-' + a + "{padding-bottom:" + 1 / t.preview_image.aspect_ratio * 100 + "%}</style>"), r += "</div></div>", $(e.selectors.productThumbs).length > 0) {
                        switch (n += '<div class="swiper-slide p-sgl__thumbs-item gallery-' + t.media_type + g + '" data-src="' + theme.Images.removeProtocol(t.preview_image.src) + '">', n += '<div class="p-sgl__thumb p-sgl__thumb--' + e.settings.sectionId + ' aspectRatio" data-src="' + theme.Images.removeProtocol(t.preview_image.src) + '"' + v + b + ' style="--ar_i: ' + 1 / t.aspect_ratio * 100 + '%">', n += '<img class="p-sgl__thumb-image lazyload ' + image_fit + '" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="' + c + '" alt="' + e.productSingleObject.title + '">', t.media_type) {
                            case "external_video":
                            case "video":
                                n += '<div class="btn play"><i class="d-icon-play _m-0i" aria-hidden="true"></i></div>';
                                break;
                            case "model":
                                n += '<div class="btn play p-0i"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-3d-badge-full-color" viewBox="0 0 26 26"><path class="icon-3d-badge-full-color-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"></path></svg></div>'
                        }
                        n += "</div></div>"
                    }
                    h++
                }
            });
            e.selectors.template;
            if ("masonry" === e.settings.imagesLayout && theme.window_W >= 992) $(e.selectors.productPhotos + " .p-sgl__photos-item").each(function(t, a) {
                $(e.selectors.productPhotos).isotope("remove", this), t + 1 == $(e.selectors.productPhotos + " .p-sgl__photos-item").length && ($(e.selectors.productPhotos).append(r), $.each($(e.selectors.productPhotos + " .p-sgl__photos-item"), function(t, a) {
                    void 0 == $(this).attr("style") && $(e.selectors.productPhotos).isotope("appended", $(this)).isotope("layout")
                }))
            });
            else {
                var g = $("#product-thumb-slide--" + e.settings.sectionId),
                    f = $("#product-photo-slide--" + e.settings.sectionId);
                g.data("vertical") && (h > 1 ? (g.removeClass("oneImageThumb"), f.removeClass("oneImagePhoto")) : (g.addClass("oneImageThumb"), f.addClass("oneImagePhoto"))), "object" == typeof e.thumbSlider && (e.thumbSlider.removeAllSlides(), e.thumbSlider.appendSlide(n)), "object" == typeof e.photoSlider ? (e.photoSlider.removeAllSlides(), e.photoSlider.appendSlide(r)) : ($(e.selectors.productPhotos).html(r), e._initPhotoZoom()), e._mediaSlider(!1)
            }
        },
        _updatePrice: function(t) {
            var e = t.variant,
                a = this;
            a.selectors.template;
            if ($(this.selectors.originalPrice).html(formatMoney_(e.price)), $(this.selectors.originalPrice.replace("#", ".")).html(formatMoney_(e.price)), e.compare_at_price > e.price ? ($(this.selectors.comparePrice).html(formatMoney_(e.compare_at_price)).removeClass("d-none"), $(this.selectors.comparePrice.replace("#", ".")).html(formatMoney_(e.compare_at_price)).removeClass("d-none"), $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses), $(this.selectors.saleLabel).removeClass("d-none")) : ($(this.selectors.comparePrice).addClass("d-none"), $(this.selectors.comparePrice.replace("#", ".")).addClass("d-none"), $(this.selectors.saleLabel).addClass("d-none"), $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses)), e.unit_price) {
                $(this.selectors.unitPrice).show().removeClass("d-none"), $(this.selectors.unitPrice.replace("#", ".")).show().removeClass("d-none");
                var i = e.unit_price_measurement.quantity_value + e.unit_price_measurement.quantity_unit;
                i += ' (<span class="unit_price">' + formatMoney_(e.unit_price) + "</span> / ", i += '<span class="base_unit">', e.unit_price_measurement && (1 != e.unit_price_measurement.reference_value && (i += e.unit_price_measurement.reference_value), i += e.unit_price_measurement.reference_unit), i += "</span>", i += "</span>)", $(this.selectors.unitPrice).html(i), $(this.selectors.unitPrice.replace("#", ".")).html(i)
            } else $(this.selectors.unitPrice).hide().addClass("d-none"), $(this.selectors.unitPrice.replace("#", ".")).hide().addClass("d-none");
            $(".fbt-item .ktlz-form-pid-" + a.productSingleObject.id).length > 0 && ($(".fbt-item .ktlz-form-pid-" + a.productSingleObject.id + " ins").html(formatMoney_(e.price)), e.compare_at_price > e.price ? $(".fbt-item .ktlz-form-pid-" + a.productSingleObject.id + " del").html(formatMoney_(e.compare_at_price)) : $(".fbt-item .ktlz-form-pid-" + a.productSingleObject.id + " del").html(""))
        },
        _updateSKU: function(t) {
            var e = t.variant;
            $(this.selectors.SKU).html(e.sku)
        },
        _onReSizeImages: function() {
            function t() {
                $(window).width() >= 768 ? $(e.selectors.template + " .content-summary").css("max-height", a.height()) : $(".content-summary").css("max-height", "")
            }
            var e = this,
                a = $(e.selectors.template + " iframe#resize-image-product");
            t(), a.each(function() {
                $(this.contentWindow || this).resize($.throttle(150, t))
            })
        },
        _initPhotoZoom: function(t) {
            var e = this;
            0 == theme.is_mobile && e.settings.zoomEnabled && KT.loadScript("zoom", function(t, a) {
                if ("ok" == a) {
                    var i = e.selectors.template + " .photos-wrapper .gallery-image";
                    $.each($(i), function(t, e) {
                        var a = $(this);
                        a.zoom({
                            url: a.attr("data-src")
                        })
                    })
                }
            })
        },
        _initPhotoSwipeFromDOM: function() {
            var t = this;
            t.dataSettings.wide && KT.loadScript("photo-swipe", function(e, a) {
                "ok" == a && theme.initPhotoSwipeFromDOM(t.selectors.template + " .photos-wrapper", ".p-sgl__photo", "IMG", function(e, a) {
                    if (0 !== $(t.selectors.template + " .photos-wrapper .p-sgl__photos-item").length && void 0 !== t.photoSlider) {
                        var i = $(t.selectors.template + " .photos-wrapper").find('.p-sgl__photos-item[data-src~="' + a.src + '"]');
                        if (0 !== $(i).length) {
                            var o = $(i).closest(".p-sgl__photos-item").index();
                            t.photoSlider.slideTo(o, 300)
                        }
                    }
                })
            })
        },
        _stickyAddCart: function() {
            var t = this;
            $(document).on("click", ".kt-stickyAddCart .toggle, .kt-stickyAddCart .btn-close", function() {
                $("#form_variants").slideToggle(), $("body").toggleClass("show-stickyAddCart"), theme.window_W >= 768 || $(".kt-stickyAddCart .infor").slideToggle()
            });
            $(window).scroll($.throttle(100, function() {
                var e = $(window).scrollTop(),
                    a = $(".kt-stickyAddCart");
                if (e > $(t.selectors.addToCart).offset().top + 60 && !1 === $(".kt-stickyAddCart").hasClass("fixed")) {
                    var i = $('header[data-header-sticky="true"] .content_header').outerHeight() || 0;
                    a.addClass("fixed"), $(".kt-stickyAddCart .position-fixed").hasClass("top") && (theme.window_W < 767 && (i = 0), $(".kt-stickyAddCart .position-fixed.top").css("top", i + "px"))
                } else e <= $(t.selectors.addToCart).offset().top && $(".kt-stickyAddCart").hasClass("fixed") && (a.removeClass("fixed"), $(".show-stickyAddCart #form_variants").slideToggle(), $("body").removeClass("show-stickyAddCart"), $(".kt-stickyAddCart .position-fixed").hasClass("top") && $(".kt-stickyAddCart .position-fixed.top").css("top", "-100%"))
            }))
        },
        _create360: function(t) {
            var e = this,
                a = this.dataJs.imgspos360.split(","),
                i = _.map(e.previewImage, "src"),
                o = _.map(e.previewImage, "width"),
                s = _.map(e.previewImage, "height"),
                r = [];
            _.forEach(i, function(t, e) {
                if (parseInt(a[0]) <= e + 1 && e + 1 < parseInt(a[1])) {
                    var i = t;
                    r.push(i)
                }
            }), KT.loadScript("threesixty", function(t, i) {
                "ok" == i && (theme.imgs360(r, a, o[a[0]], s[a[0]], e.id), $(".kt_open360_" + e.id).removeClass("d-none"))
            })
        },
        _stockCountdown: function() {
            function t(t, e) {
                return Math.floor(Math.random() * (e - t + 1) + t)
            }

            function e(t) {
                a(t, p), o = setTimeout(function() {
                    a(t)
                }, 6e4 * l), s = setInterval(function() {
                    a(t)
                }, 6e3 * n)
            }

            function a(e, a, o) {
                var n = $(e);
                if (void 0 == (a = a) && (a = p - 1, p < r && (p = a, a = t(d, c))), a > c) return !1;
                var l = theme.productStrings.stockMessage[0] + ' <span class="count">' + a + "</span> " + theme.productStrings.stockMessage[1];
                n.addClass("items-count").find("p").html(l);
                var h = h || n.data().stockBgProcess;
                n.find(".count").css({
                    "background-color": h,
                    color: "#fff"
                }), setTimeout(function() {
                    n.find(".count").css({
                        "background-color": "#fff",
                        color: h
                    })
                }, 400), n.find(".count").text(a);
                var u = 100 * a / i;
                a < 10 && n.find(".progress").addClass("less-than-ten"), setTimeout(function() {
                    n.find(".progress-bar").css("width", u + "%").attr("aria-valuenow", u)
                }, 300), p = a, (c = a) <= d && clearTimeout(s)
            }
            var i = 70,
                o = null,
                s = null,
                r = 1,
                n = 1.7,
                l = .17,
                d = 0,
                c = 0,
                p = 0,
                h = 0;
            return {
                init: function(a) {
                    var i = $(a).data();
                    d = parseInt(i.stockFrom), c = parseInt(i.stockTo), p = parseInt(i.remainingItems) || t(d, c), h = i.stockBgProcess, e(a)
                },
                progressbar: e,
                updateMeter: a
            }
        },
        _realTimeVisitor: function(t) {
            var e = $(t);
            $(function(t) {
                var a = e.attr("data-counter-max"),
                    i = 1,
                    o = a;
                i = Math.ceil(i), o = Math.floor(o);
                var s = Math.floor(Math.random() * (o - i + 1)) + i,
                    r = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
                    n = "",
                    l = "",
                    d = ["10", "20", "15"],
                    n = "",
                    l = "",
                    c = "";
                setInterval(function() {
                    if (n = Math.floor(Math.random() * r.length), l = r[n], 1 >= (s = parseInt(s) + parseInt(l))) {
                        c = Math.floor(Math.random() * d.length);
                        s += d[c]
                    }(s < 1 || s > a) && (s = Math.floor(Math.random() * (o - i + 1)) + i), e.find("#nb_counter").html("+" + parseInt(s)), e.show()
                }, parseInt(e.attr("data-interval-time")))
            })
        },
        _dateFromTo: function(t) {
            var e = $(t);
            KT.loadScript("moment", function(t, a) {
                "ok" == a && function() {
                    var t = theme.function.product_delivery,
                        a = parseInt(t.fromDate),
                        i = parseInt(t.toDate);
                    KT.loadScript("momentlocale", function(o, s) {
                        if ("ok" == s) {
                            moment.locale(shopLocale);
                            var r = moment().add(a, "days");
                            if (t.offSaturday && "6" == r.format("d") && (a++, r = moment().add(a, "days")), t.offSunday && "0" == r.format("d") && (a++, r = moment().add(a, "days")), i > a) {
                                var n = moment().add(i, "days");
                                t.offSaturday && "6" == n.format("d") && (i++, n = moment().add(i, "days")), t.offSunday && "0" == n.format("d") && (i++, n = moment().add(i, "days"))
                            }
                            if ($.each(t.offDays, function(t, e) {
                                    var o = e.split("/")[1],
                                        s = e.split("/")[0],
                                        l = e.split("/")[2];
                                    r.format("DD") === o && r.format("MM") === s && ("****" !== r.format("YYYY") && r.format("YYYY") !== l || (a++, r = moment().add(a, "days"))), i > a && n.format("DD") === o && n.format("MM") === s && ("****" !== n.format("YYYY") && n.format("YYYY") !== l || (i++, n = moment().add(i, "days")))
                                }), $(".product_delivery .timeDay").length > 0) {
                                var l = $(".product_delivery .timeDay");
                                e.append("<style>span.timeDay{display: inline-block}.timeDay .block{display: inline-block}.timeDay span.label{padding: 0 4px}</style>"), KT.loadScript("countdown", function(t, e) {
                                    if ("ok" == e) {
                                        var a = moment().endOf("day").format(),
                                            i = '<div class="block cdhrs"><span class="flip-top">00</span><span class="label">' + theme.strings.cdhrs + "</span></div>";
                                        i += '<div class="block cdmins"><span class="flip-top">00</span><span class="label">' + theme.strings.cdmin + "</span></div>", l.html(i);
                                        var o = l.find(".cdhrs .flip-top"),
                                            s = l.find(".cdmins .flip-top");
                                        l.find(".cdsecs .flip-top"), l.countdown(moment(a).toDate()).on("update.countdown", function(t) {
                                            o.text(t.strftime("%H")), s.text(t.strftime("%M"))
                                        }).on("finish.countdown", function(t) {
                                            l.parent().remove()
                                        })
                                    }
                                })
                            }
                            if (e.find(".fromDate").html(r.format(theme.function.product_delivery.deliveryFormatDate)), i > a && (e.find(".toDate i").html(n.format(theme.function.product_delivery.deliveryFormatDate)), e.find(".toDate").removeClass("d-none")), e.slideDown(), e.parents(".shipping_rates").length <= 0) return;
                            e.parents(".shipping_rates").show()
                        }
                    })
                }()
            })
        },
        _responTableGroup: function() {
            $(this.selectors.template + " .table-products").scroll($.throttle(100, function() {
                var t = $(this);
                $(this).scrollLeft() >= 80 && 0 == $(this).hasClass("mini") ? t.addClass("mini") : $(this).scrollLeft() < 80 && $(this).hasClass("mini") && t.removeClass("mini")
            }))
        },
        onUnload: function() {
            this.$container.off(), this.$container.find(".kt_countdown").off()
        }
    }), t
}(), theme.StoreAvailability = function() {
    function t(t) {
        this.$container = $(t), this.$data = this.$container.data(), this.productTitle = this.$data.productTitle, this.hasOnlyDefaultVariant = this.$data.hasOnlyDefaultVariant
    }
    var e = {
            modal: "[data-store-availability-modal-open]",
            modalProductTitle: "[data-store-avai-modal-product-title]",
            modalVariantTitle: "[data-store-avai-modal-variant-title]"
        },
        a = {
            hidden: "d-none"
        };
    return t.prototype = Object.assign({}, t.prototype, {
        updateContent: function(t) {
            var i = this.$data.baseUrl + "variants/" + t + "/?section_id=store-availability",
                o = this;
            $.ajax({
                url: i,
                type: "GET",
                dataType: "html",
                success: function(i) {
                    i = i.split("\x3c!--lz_sc--\x3e")[1].split("\x3c!-- modal --\x3e"), o.$container.html(i[0]);
                    var s = $("#store-avai-modal-" + t);
                    if (s.length <= 0) {
                        $(".content_for_extension").append(i[1]);
                        if ((s = $("#store-avai-modal-" + t)).find(e.modalProductTitle).text(o.productTitle), o.hasOnlyDefaultVariant) {
                            s.find(e.modalVariantTitle).addClass(a.hidden)
                        }
                    }
                }
            })
        }
    }), t
}(), theme.recentlySection = function() {
    return function(t) {
        var e = $(t);
        if (e.find(".load_recent").length > 0) {
            theme.SwiperSection(t);
            var a = localStorage.getItem("kt-recent");
            if (null !== a) {
                (o = (o = a.split(",")).reverse()).join() == product_id && e.addClass("no-prds").hide();
                var i = Shopify.root_url + "/search?q=id:" + o.join("%20OR%20id:");
                null != product_id && (i += "%20NOT%20id:" + product_id), i += "&view=recently", e.find(".load_recent").attr("data-include", i).addClass("lazyload")
            } else e.addClass("no-prds").hide();
            var o = null !== a ? a.split(",") : new Array;
            o.includes(product_id + "") || (o.length >= 10 && o.pop(), o[o.length] = product_id, o = o.toString(), localStorage.setItem("kt-recent", o))
        }
    }
}(), theme.fbtPrds = ($(document).on("change", ".fbt-prds select, .fbt-prds .form-check-input", function(t) {
    var e = 0,
        a = 0;
    $.each($(".fbt-info select"), function(t, i) {
        if ($(this).parents(".fbt-item").find(".form-check-input").is(":checked")) {
            var o = $(this).find('option[value="' + $(this).val() + '"]');
            e += parseInt(o.attr("data-price")), a += parseInt(o.attr("data-cprice"))
        }
    });
    var i = $(this),
        o = this.nodeName;
    if ($(".fbt-btn ins").html(formatMoney_(e)), a > e ? $(".fbt-btn del").html(formatMoney_(a)).show() : $(".fbt-btn del").hide(), "INPUT" !== o) {
        var s = i.find("option:selected").data();
        i.parent().find(".product-price ins").html(formatMoney_(s.price)), s.cprice > s.price ? i.parent().find(".product-price del").html(formatMoney_(s.cprice)).show() : i.parent().find(".product-price del").html("")
    }
    var r = i.parents("[data-pid]").data("pid");
    if ("INPUT" === o) {
        n = i.parent().find('input[name*="updates"]');
        return i.is(":checked") ? ($(".fbt-item-" + r).css("opacity", 1), n.val(1)) : ($(".fbt-item-" + r).css("opacity", .5), n.val(0)), void setTimeout(function() {
            $("#Swiper-fbt .swiper")[0].swiper.update()
        }, 300)
    }
    var n;
    (n = i.parent().find('input[name*="updates"]')).attr("name", "updates[" + i.val() + "]");
    var l = theme.psjson_lib[parseInt(r)],
        d = _.find(l, {
            id: parseInt(i.val())
        });
    if (void 0 != d && null != d.featured_image) {
        var c = $(".fbt-item-" + r),
            p = c.find(".primary-thumb img"),
            h = void 0 != p.attr("src") ? p.attr("src").split(",")[0] : void 0;
        void 0 == h && (h = void 0 != p.attr("srcset") ? p.attr("srcset").split(",")[0] : void 0);
        var u = !1;
        if (d.featured_image && void 0 != h && (u = h.split("/").slice(-1)[0].indexOf(theme.Images.getName(d.featured_image.src)) < 0), !0 === u) {
            var m = d.featured_image.src,
                g = _.last(m.split("."));
            (new Image).src = theme.Images.removeProtocol(m.replace("." + g, "_540x." + g));
            var f = '<div class="primary-thumb ' + theme.Images.imgFit(d.featured_image.width, d.featured_image.height) + '"><img class="lazyload"';
            f += 'src="' + theme.Images.removeProtocol(m.replace("." + g, "_540x." + g)) + '"', f += 'data-src="' + theme.Images.removeProtocol(m.replace("." + g, "_{width}x." + g)) + '"', f += 'data-widths="[240]"', f += 'data-sizes="auto"', f += 'alt=""></div>', c.find(".aspectRatio").append(f), c.find(".primary-thumb").first().remove()
        }
    }
}), $(document).on("click", ".fbt-view", function() {
    $(".fbt-info").slideToggle(), $(".fbt-view .more, .fbt-view .less").toggle()
}), void $(document).on("click.bs.dropdown", ".header .main-header .dropdown", function(t) {
    t.stopPropagation()
})), theme.initPhotoSwipeFromDOM = function(t, e, a, i) {
    $(".pswp").removeAttr("style");
    for (var o = $(t), s = function(i) {
            (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1;
            var o = function t(e, a) {
                return e && (a(e) ? e : t(e.parentNode, a))
            }(i.target || i.srcElement, function(t) {
                return t.tagName && t.tagName.toUpperCase() === a
            });
            if (o) {
                for (var s, n = $(o).parents(t), l = n.find(e + " [data-size]"), d = l.length, c = 0, p = 0; p < d; p++) {
                    if (l[p] === o) {
                        s = c;
                        break
                    }
                    c++
                }
                return s >= 0 && r(s, n), !1
            }
        }, r = function(t, a, o, s) {
            var r, n, l, d = $(".pswp")[0];
            if (l = function(t) {
                    var a = $(t).find(e + " [data-size]"),
                        i = [];
                    return _.forEach(a, function(t, e) {
                        var a = new Object;
                        a.src = $(t).attr("data-srcfix"), a.w = $(t).attr("data-size").split("x")[0], a.h = $(t).attr("data-size").split("x")[1], i.push(a)
                    }), i
                }(a), n = {
                    history: !1,
                    focus: !1,
                    galleryUID: $(a).attr("data-pswp-uid"),
                    getThumbBoundsFn: function(t) {
                        var i = $(a).find(e + " [data-size]")[t],
                            o = window.pageYOffset || document.documentElement.scrollTop,
                            s = i.getBoundingClientRect();
                        return {
                            x: s.left,
                            y: s.top + o,
                            w: s.width
                        }
                    },
                    shareButtons: [{
                        id: "facebook",
                        label: "Share on Facebook",
                        url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                    }, {
                        id: "twitter",
                        label: "Tweet",
                        url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                    }, {
                        id: "pinterest",
                        label: "Pin it",
                        url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                    }]
                }, s)
                if (n.galleryPIDs) {
                    for (var c = 0; c < l.length; c++)
                        if (l[c].pid == t) {
                            n.index = c;
                            break
                        }
                } else n.index = parseInt(t, 10) - 1;
            else n.index = parseInt(t, 10);
            isNaN(n.index) || (o && (n.showAnimationDuration = 0), (r = new PhotoSwipe(d, PhotoSwipeUI_Default, l, n)).init(), r.listen("afterChange", function() {
                i(r.getCurrentIndex(), r.currItem)
            }))
        }, n = 0, l = o.length; n < l; n++) o[n].setAttribute("data-pswp-uid", n + 1), o[n].onclick = s
};